import { localeBonusesType } from '../en-US'

export const bonuses: localeBonusesType = {
  yourCashback: 'Su reembolso en efectivo',
  yourFirstDeposit: 'Su primer depósito',
  yourJackpot: 'Tu premio gordo',

  youGot: 'Tienes',

  bonuses: 'Bonificaciones',
  moreAboutStock: 'Más sobre el stock',

  ALL: 'Todos',
  Cashback: 'Devolución de efectivo',
  SportDiscount: 'Descuento deportivo',
  FirstDeposit: 'Primer depósito',
  DetractedFirstDepositBonusByWithdrawal: 'Bono de primer depósito detraído por retiro',
  IncreasedBySO: 'Aumentado por SO',
  TransferBonusesToBalance: 'Transferir bonificaciones al saldo',
  LuckySpin: 'Giro afortunado',
  balanceConvertedSuccess: 'Saldo agregado con éxito',
  exchange: 'Intercambio',
  bonusBalanceOnYourAccount: 'Su saldo actual de bonificación',
  exchangeRate: 'Tipo de cambio',
  balanceMustBeLess: 'El saldo debe ser inferior a',
  toCompleteExchange: 'para completar el intercambio',

  cashbackHistory: 'Historial de devolución de efectivo',
  from: 'De',
  to: 'Para',
  show: 'Mostrar',
  date: 'Fecha',
  filters: 'Filtros',
  type: 'Tipo',
  amount: 'Importe',
  cashbackNotify: 'Ha recibido un reembolso en efectivo por la cantidad de',
  thankYou: 'Gracias',
  firstDepositNotify: 'Ha recibido el primer depósito por la cantidad de',

  currentBonusBalance: 'Su saldo actual de bonificación',
  youWonJackpot: 'Has ganado el premio gordo!',
  pickUp: 'Recoger',
  takeYourPrize: 'Toma tu premio',
}
